import Cross from './Cross';

export default Cross;
